ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}

window.moment = require '../../../../node_modules/moment/moment.js'
ProductReviews.Views.ReviewList = require '../views/product_reviews_review_list'
ProductReviews.Model = require '../models/product_review'
ProductReviews.Helpers = require '../../common/helpers'

ProductReviews.Collection = Backbone.Collection.extend
  model: ProductReviews.Model

  initialize: (models, @options) ->
    @page = 1
    @locale = 'en_US'
    @showParams = ''
    @sortBy = 'most_recent'
    _.extend this, @options
    _.bindAll this, 'paginationSuccess', 'paginationError'

  _prepareModel: (model, options) ->
    _.extend options, @options
    delete options.parse
    Backbone.Collection::_prepareModel.call this, model, options

  url: ->
    "#{@rootUrl}/product_review_proxy/reviews.json?deal_uuid=#{@dealUuid}&locale=#{@locale}&sort=#{@sortBy}&limit=#{@limit()}&offset=#{@offset()}&show=#{@showParams}"

  sync: (method, collection, options = {}) ->
    options.timeout = ProductReviews.timeout
    Backbone.Collection::sync.call this, method, collection, options

  limit: ->
    @pageSize

  offset: ->
    (@page - 1) * @pageSize

  parse: (response) ->
    return unless response.reviewable
    if @displayOptions.isTouch and user = response.user
      @displayOptions.userUpvotedReviews = user.upvotes or []
    ProductReviews.Helpers.extractReviews response, @displayOptions, I18n, moment

  nextPage: (sortOrder) ->
    @previousSortBy = @sortBy
    @previousPage = @page
    @page++
    @sortBy = sortOrder if sortOrder
    @action = 'nextPage'
    @fetch
      success: @paginationSuccess
      error: @paginationError
      remove: false

  resortReviews: (sortOrder) ->
    @previousSortBy = @sortBy
    @previousPage = @page
    @page = 1
    @sortBy = sortOrder if sortOrder
    @action = 'resortReviews'
    @fetch
      success: @paginationSuccess
      error: @paginationError
      reset: true

  paginationSuccess: (response) ->
    @view.render(new ProductReviews.Views.ReviewList collection: this)

  paginationError: (response) ->
    @page = @previousPage
    @sortBy = @previousSortBy
    @view.showPaginationError @action

  recordUpvote: (id) ->
    @displayOptions.userUpvotedReviews.push id

  recordUnvote: (id) ->
    @displayOptions.userUpvotedReviews = _.without @displayOptions.userUpvotedReviews, id

  fetchedReviews: ->
    @models.slice(@offset())


module.exports = ProductReviews.Collection
